import type { useToast } from "@/hooks/use-toast";
import { getHumanError } from "@/lib/app-errors";

type ToastFn = ReturnType<typeof useToast>["toast"];

export function showSuccessToast(
  toast: ToastFn,
  title: string,
  description?: string,
) {
  return toast({
    variant: "success",
    title,
    description,
  });
}

export function showErrorToast(
  toast: ToastFn,
  options: {
    error?: unknown;
    action: string;
    fallbackTitle?: string;
  },
) {
  const human = getHumanError(options.error, { action: options.action });
  return toast({
    variant: "destructive",
    title: options.fallbackTitle ?? human.title,
    description: human.description,
  });
}

export function showInfoToast(
  toast: ToastFn,
  title: string,
  description?: string,
) {
  return toast({
    title,
    description,
  });
}
